import { render } from "./Vimeo.vue?vue&type=template&id=5ca374bc"
import script from "./Vimeo.vue?vue&type=script&lang=js"
export * from "./Vimeo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__